
export default function Navbtn({website, val, inx, arr, action, isDashboard}) {
    
    return (
        <button key={`navbar_btn_${inx}`} dir='rtl' style={{width:`${100/arr.length}%`, backgroundColor:`${website.settings.theme.primary_color}`, color:`${website.settings.theme.accent_color}`}} className="navBtns" onClick={()=>{
            if(!isDashboard){
                window.scrollTo({
                    top:0,
                    'behavior':'smooth'
                });
            }
            action();
        }}>{val.btnName}</button>
    )
}
